import { render, staticRenderFns } from "./Service2.vue?vue&type=template&id=be4cf786&"
import script from "./Service2.vue?vue&type=script&lang=js&"
export * from "./Service2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports